/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import CanvasEditorContainer from "./containers/CanvasEditorContainer";

/**
 * Canvas Editor app root.
 * Provides base component for rendering canvas pages
 */
export class CanvasEditor extends WidgetBase {
	/**
	 * Override WidgetBase#render to produce a virtual DOM tree.
	 * @returns {HNode} Each time render() executes, it should build the entire virtual DOM tree.
	 */
	protected render() {
		// Use WidgetBase#classes() to assign CSS classnames from the theme to the virtual DOM nodes.
		return (
			<div classes="c8_canvas_root">
				<CanvasEditorContainer />
			</div>
		);
	}
}

export default CanvasEditor;
